export default "<p>descriptions-edit-more-btn works!</p>\n"